import React from 'react'

const Jva_sss = () => {
    return (
        <div className='container'>
            <article>
  <h1 class="title">String vs StringBuilder vs StringBuffer in Java</h1>

  <div class="text">
    <p ><strong>Prerequisites: </strong>String, 
      Initialize a
        String&nbsp;<br/>Consider below code with three concatenation functions with three different types of
      parameters, String, StringBuffer and StringBuilder.</p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
       
        <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
          role="tabpanel" aria-labelledby="tablist1-tab1" id="tablist1-panel1">
          <div class="code-block">
            
            <div class="code-container">
              <div id="highlighter_588024" class="syntaxhighlighter nogutter">
               
                      <td class="containers">
                        <div class="container">
                          <div class="line number1 index0 alt2"><code
                              class="comment">// Java program to demonstrate difference</code></div>
                          <div class="line number2 index1 alt1"><code
                              class="comment">// between String, StringBuilder and StringBuffer</code></div>
                          <div class="line number3 index2 alt2"><code class="keywords">class</code> <code
                              class="plain">NooBsforNooBs &#123;</code></div>
                          <div class="line number4 index3 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// Concatenates to String</code></div>
                          <div class="line number5 index4 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">concat1(String s1)</code></div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number7 index6 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">s1 = s1 + </code><code class="string">"forNooBs"</code><code
                              class="plain">;</code></div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number9 index8 alt2">&nbsp;</div>
                          <div class="line number10 index9 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// Concatenates to StringBuilder</code></div>
                          <div class="line number11 index10 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">concat2(StringBuilder s2)</code></div>
                          <div class="line number12 index11 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number13 index12 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">s2.append(</code><code class="string">"forNooBs"</code><code
                              class="plain">);</code></div>
                          <div class="line number14 index13 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number15 index14 alt2">&nbsp;</div>
                          <div class="line number16 index15 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// Concatenates to StringBuffer</code></div>
                          <div class="line number17 index16 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">concat3(StringBuffer s3)</code></div>
                          <div class="line number18 index17 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number19 index18 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">s3.append(</code><code class="string">"forNooBs"</code><code
                              class="plain">);</code></div>
                          <div class="line number20 index19 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number21 index20 alt2">&nbsp;</div>
                          <div class="line number22 index21 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number23 index22 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number24 index23 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">String s1 = </code><code class="string">"NooBs"</code><code
                              class="plain">;</code></div>
                          <div class="line number25 index24 alt2">&nbsp;</div>
                          <div class="line number26 index25 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// s1 is not changed</code></div>
                          <div class="line number27 index26 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">concat1(s1);</code></div>
                          <div class="line number28 index27 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code><code class="string">"String: "</code> <code
                              class="plain">+ s1);</code></div>
                          <div class="line number29 index28 alt2">&nbsp;</div>
                          <div class="line number30 index29 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">StringBuilder s2 = </code><code class="keywords">new</code> <code
                              class="plain">StringBuilder(</code><code class="string">"NooBs"</code><code
                              class="plain">);</code></div>
                          <div class="line number31 index30 alt2">&nbsp;</div>
                          <div class="line number32 index31 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// s2 is changed</code></div>
                          <div class="line number33 index32 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">concat2(s2);</code></div>
                          <div class="line number34 index33 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code><code class="string">"StringBuilder: "</code>
                            <code class="plain">+ s2);</code></div>
                          <div class="line number35 index34 alt2">&nbsp;</div>
                          <div class="line number36 index35 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">StringBuffer s3 = </code><code class="keywords">new</code> <code
                              class="plain">StringBuffer(</code><code class="string">"NooBs"</code><code
                              class="plain">);</code></div>
                          <div class="line number37 index36 alt2">&nbsp;</div>
                          <div class="line number38 index37 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// s3 is changed</code></div>
                          <div class="line number39 index38 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">concat3(s3);</code></div>
                          <div class="line number40 index39 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code><code class="string">"StringBuffer: "</code> <code
                              class="plain">+ s3);</code></div>
                          <div class="line number41 index40 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number42 index41 alt1"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="output"><strong>Output</strong>
      <pre>String: NooBs <br/>
  StringBuilder: NooBsforNooBs <br/>
  StringBuffer: NooBsforNooBs</pre>
    </div>
    <p ><strong>Explanation:</strong>&nbsp;</p>
    <ol>
      <li ><strong>Concat1</strong>: In this method, we pass a string “NooBs” and perform “s1
        = s1 + ”forNooBs”. The string passed from main() is not changed, this is due to the fact that String is
        <strong>immutable</strong>. Altering the value of string creates another object and s1 in concat1() stores
        reference of the new string. References s1 in main() and cocat1() refer to different strings.</li>
      <li ><strong>Concat2</strong>: In this method, we pass a string “NooBs” and perform
        “s2.append(“forNooBs”)” which changes the actual value of the string (in main) to “NooBsforNooBs”. This is due
        to the simple fact that StringBuilder is <strong>mutable</strong> and hence changes its value.</li>
      <li ><strong>Concat3</strong>: StringBuffer is similar to StringBuilder except for one
        difference that StringBuffer is thread-safe, i.e., multiple threads can use it without any issue. The
        thread-safety brings a penalty of performance.&nbsp;<br/><strong>When to use which one :</strong></li>
    </ol>
    <ul>
      <li >If a string is going to remain constant throughout the program, then use the String
        class object because a String object is immutable.</li>
      <li >If a string can change (for example: lots of logic and operations in the
        construction of the string) and will only be accessed from a single thread, using a StringBuilder is good
        enough.</li>
      <li >If a string can change and will be accessed from multiple threads, use a
        StringBuffer because StringBuffer is synchronous, so you have thread-safety.</li>
      <li >If you don’t want thread-safety than you can also go with StringBuilder class as it
        is not synchronized.</li>
    </ul>
    <p ><strong>Conversion between types of strings in Java</strong></p>
    <p >Sometimes there is a need for converting a string object of different classes like
      String, StringBuffer, StringBuilder to one-another. Below are some techniques to do the same.&nbsp;</p><br/>
    <br/>
    <p ><strong>1. From String to StringBuffer and StringBuilder:&nbsp;</strong></p>
    <p >This one is easy. We can directly pass the String class object to StringBuffer and
      StringBuilder class constructors. As the String class is immutable in java, so for editing a string, we can
      perform the same by converting it to StringBuffer or StringBuilder class objects. Below is the java program to
      demonstrate the same.&nbsp;</p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
        
       
        <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
          role="tabpanel" aria-labelledby="tablist2-tab1" id="tablist2-panel1">
          <div class="code-block">
            
            <div class="code-container">
              <div id="highlighter_260812" class="syntaxhighlighter nogutter">
               
                      <td class="containers">
                        <div class="container">
                          <div class="line number1 index0 alt2"><code
                              class="comment">// Java program to demonstrate conversion from</code></div>
                          <div class="line number2 index1 alt1"><code
                              class="comment">// String to StringBuffer and StringBuilder.</code></div>
                          <div class="line number3 index2 alt2"><code class="keywords">public</code> <code
                              class="keywords">class</code> <code class="plain">Test &#123;</code></div>
                          <div class="line number4 index3 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number5 index4 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">String str = </code><code class="string">"NooBs"</code><code
                              class="plain">;</code></div>
                          <div class="line number7 index6 alt2">&nbsp;</div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// conversion from String object to StringBuffer</code></div>
                          <div class="line number9 index8 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">StringBuffer sbr = </code><code class="keywords">new</code> <code
                              class="plain">StringBuffer(str);</code></div>
                          <div class="line number10 index9 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">sbr.reverse();</code></div>
                          <div class="line number11 index10 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(sbr);</code></div>
                          <div class="line number12 index11 alt1">&nbsp;</div>
                          <div class="line number13 index12 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// conversion from String object to StringBuilder</code></div>
                          <div class="line number14 index13 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">StringBuilder sbl = </code><code class="keywords">new</code> <code
                              class="plain">StringBuilder(str);</code></div>
                          <div class="line number15 index14 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">sbl.append(</code><code class="string">"ForNooBs"</code><code
                              class="plain">);</code></div>
                          <div class="line number16 index15 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(sbl);</code></div>
                          <div class="line number17 index16 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number18 index17 alt1"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="output"><strong>Output</strong>
      <pre>sBooN
  NooBsForNooBs</pre>
    </div>
    <p ><strong>2. From StringBuffer and StringBuilder to String:</strong>&nbsp;</p>
    <p >This conversion can be performed using <i>toString()</i> method which is overridden in
      both StringBuffer and StringBuilder classes.&nbsp;<br/>Below is the java program to demonstrate the same. Note that
      while we use <i>toString()</i> method, a new String object(in Heap area) is allocated and initialized to the
      character sequence currently represented by the StringBuffer object, which means the subsequent changes to the
      StringBuffer object do not affect the contents of the String object.&nbsp;</p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
        
        
       
        
               
                      <td class="code">
                        <div class="containers">
                          <div class="line number1 index0 alt2"><code
                              class="comment">// Java program to demonstrate conversion from</code></div>
                          <div class="line number2 index1 alt1"><code
                              class="comment">// String to StringBuffer and StringBuilder.</code></div>
                          <div class="line number3 index2 alt2"><code class="keywords">public</code> <code
                              class="keywords">class</code> <code class="plain">Test &#123;</code></div>
                          <div class="line number4 index3 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number5 index4 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">StringBuffer sbr = </code><code class="keywords">new</code> <code
                              class="plain">StringBuffer(</code><code class="string">"NooBs"</code><code
                              class="plain">);</code></div>
                          <div class="line number7 index6 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">StringBuilder sbdr = </code><code class="keywords">new</code> <code
                              class="plain">StringBuilder(</code><code class="string">"Hello"</code><code
                              class="plain">);</code></div>
                          <div class="line number8 index7 alt1">&nbsp;</div>
                          <div class="line number9 index8 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// conversion from StringBuffer object to String</code></div>
                          <div class="line number10 index9 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">String str = sbr.toString();</code></div>
                          <div class="line number11 index10 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code></div>
                          <div class="line number12 index11 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="string">"StringBuffer object to String : "</code><code class="plain">);</code>
                          </div>
                          <div class="line number13 index12 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(str);</code></div>
                          <div class="line number14 index13 alt1">&nbsp;</div>
                          <div class="line number15 index14 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// conversion from StringBuilder object to String</code></div>
                          <div class="line number16 index15 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">String str1 = sbdr.toString();</code></div>
                          <div class="line number17 index16 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code></div>
                          <div class="line number18 index17 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="string">"StringBuilder object to String : "</code><code class="plain">);</code>
                          </div>
                          <div class="line number19 index18 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(str1);</code></div>
                          <div class="line number20 index19 alt1">&nbsp;</div>
                          <div class="line number21 index20 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// changing StringBuffer object sbr</code></div>
                          <div class="line number22 index21 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// but String object(str) doesn't change</code></div>
                          <div class="line number23 index22 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">sbr.append(</code><code class="string">"ForNooBs"</code><code
                              class="plain">);</code></div>
                          <div class="line number24 index23 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(sbr);</code></div>
                          <div class="line number25 index24 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(str);</code></div>
                          <div class="line number26 index25 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number27 index26 alt2"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
            
          </div>
        
    <div class="output"><strong>Output</strong>
      <pre>StringBuffer object to String :  <br />
  NooBs <br />
  StringBuilder object to String :  <br />
  Hello <br />
  NooBsForNooBs <br />
  NooBs</pre>
    </div>
    <p ><strong>3. From StringBuffer to StringBuilder or vice-versa:&nbsp;</strong></p>
    <p >This conversion is tricky. There is no direct way to convert the same. In this case,
      We can use a String class object. We first convert the StringBuffer/StringBuilder object to String using
      <i>toString()</i> method and then from String to StringBuilder/StringBuffer using constructors.</p>
    <p >Below is the java program to demonstrate the same.</p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
       
       
     
               
                      <td class="code">
                        <div class="containers">
                          <div class="line number1 index0 alt2"><code
                              class="comment">// Java program to demonstrate conversion from</code></div>
                          <div class="line number2 index1 alt1"><code
                              class="comment">// String to StringBuffer and StringBuilder.</code></div>
                          <div class="line number3 index2 alt2"><code class="keywords">public</code> <code
                              class="keywords">class</code> <code class="plain">Test &#123;</code></div>
                          <div class="line number4 index3 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number5 index4 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">StringBuffer sbr = </code><code class="keywords">new</code> <code
                              class="plain">StringBuffer(</code><code class="string">"NooBs"</code><code
                              class="plain">);</code></div>
                          <div class="line number7 index6 alt2">&nbsp;</div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// conversion from StringBuffer</code></div>
                          <div class="line number9 index8 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// object to StringBuilder</code></div>
                          <div class="line number10 index9 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">String str = sbr.toString();</code></div>
                          <div class="line number11 index10 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">StringBuilder sbl = </code><code class="keywords">new</code> <code
                              class="plain">StringBuilder(str);</code></div>
                          <div class="line number12 index11 alt1">&nbsp;</div>
                          <div class="line number13 index12 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(sbl);</code></div>
                          <div class="line number14 index13 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number15 index14 alt2"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
            
         
    <div class="output"><strong>Output</strong>
      <pre>NooBs</pre>
    </div>
    <p ><strong>Conclusion:</strong>&nbsp;&nbsp;</p>
    <ul>
      <li >Objects of String are immutable, and objects of StringBuffer and StringBuilder are
        mutable.</li>
      <li >StringBuffer and StringBuilder are similar, but StringBuilder is faster and
        preferred over StringBuffer for the single-threaded program. If thread safety is needed, then StringBuffer is
        used.</li>
    </ul>
  
</article>
        </div>
    )
}

export default Jva_sss
